import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=371bf6fa&scoped=true"
import script from "./CouponList.vue?vue&type=script&lang=js"
export * from "./CouponList.vue?vue&type=script&lang=js"
import style0 from "./CouponList.vue?vue&type=style&index=0&id=371bf6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371bf6fa",
  null
  
)

export default component.exports